module.exports = __webpack_public_path__ + "img/InicioSinFotosNiCirculos.625477e4.png";